import React from 'react';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import BooksPreview from './BooksPreview';
import QuotesPreview from './QuotesPreview';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import RichEditor from '@/components/forms/RichEditor';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import { FaUserSecret } from 'react-icons/fa';
import { FaTags } from 'react-icons/fa6';
import SectionTitle from '@/components/SectionTitle';
import CustomSelect from '@/components/CustomSelect';

const HomeScreen = () => {
  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: 'Home',
          titleClassName: 'text-white',
        },
      }}
    >
      <ScrollableContainer>
        <BooksPreview />
        <QuotesPreview />
        <SectionTitle className='mt-6 mb-2 text-white  text-lg' label='Other' />
        <section className='flex gap-4 rounded-lg '>
          <Link to='/authors' className='mr-3 rounded-lg flex items-center justify-center flex-col'>
            <div className='w-10 h-10 border border-neutral-800 flex items-center justify-center rounded-xl mb-2'>
              <FaUserSecret className='text-red-500' />
            </div>
            <h2 className='font-medium text-sm text-white'>Authors</h2>
          </Link>
          <Link to='/tags' className=' rounded-lg flex items-center justify-center flex-col'>
            <div className='w-10 h-10 border border-neutral-800 flex items-center justify-center rounded-xl mb-2'>
              <FaTags className='text-violet-500' />
            </div>
            <h2 className='font-medium text-sm text-white'>Tags</h2>
          </Link>
        </section>
      </ScrollableContainer>
    </Screen>
  );
};

export default HomeScreen;
